type SessionState = {
  loading: boolean;
  error: boolean;
  isCompleteSession: boolean;
};

type State = {
  session: SessionState;
};

export type Action = { type: 'UPDATE_SESSION'; payload: Partial<SessionState> };

export const initialState: State = {
  session: { loading: false, error: false, isCompleteSession: false },
};

export const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'UPDATE_SESSION':
      return { ...state, session: { ...state.session, ...action.payload } };
    default:
      return state;
  }
};
